module.exports = __webpack_public_path__ + "static/media/sb.5bc69a36.svg";